/* src/app/private/components/temp-student-profile/update-student-registration-profile/update-student-registration-profile.component.scss */
.profile-input {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.profile-select {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.p-datepicker-inpu {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
/*# sourceMappingURL=update-student-registration-profile.component.css.map */
